import { render } from "./ViewModel.vue?vue&type=template&id=21ee9168"
import script from "./ViewModel.vue?vue&type=script&lang=js"
export * from "./ViewModel.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__